var exports = {
  "yl": "xdbfd91f1--fbba3c--modal",
  "WK": "xdbfd91f1--fbba3c--modal--button",
  "DD": "xdbfd91f1--fbba3c--title",
  "Qp": "xdbfd91f1--fbba3c--work_time",
  "p_": "xdbfd91f1--fbba3c--list",
  "x3": "xdbfd91f1--fbba3c--list-item",
  "nf": "xdbfd91f1--fbba3c--link",
};

module.exports = exports;
